import { entrances } from '@/mocks/entrances';
import Reveal from '@/components/base/Reveal';

export default function EntranceSection() {
  return (
    <section id="entrances" className="w-full bg-background-200 px-4 py-16 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-7xl">
        <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-[11px] tracking-[0.24em] text-primary-600">
              QUICK ACCESS / 入口
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              想直接跳进某类黑料，从这些入口走
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            深夜黑料把高频需求做成入口：塌房、翻车、争议、丑闻各有归处，不用从第一条慢慢往下翻。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {entrances.map((item, index) => (
            <Reveal key={item.id} delay={(index % 4) * 70}>
              <a
                href="#brief"
                className="group flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <span className="font-label text-xs text-foreground-400">{item.count} 条</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {item.name}
                </h3>
                <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
                <span className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600">
                  进入
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}